<template>
<modal name="editorResizeTip"
      transition="nice-modal-fade"
      :pivotY="0.3"
      @before-open="resizeTipOpen"
      width=420
      height=210
    >
  <div class="resize-tip">
    <div class="title">
      <div class="close-button" @click="close">
        <i></i>
      </div>
    </div>
    <div class="content">
      <div>
        切换画布比例将清除所有镜头
      </div>
    </div>
    <div class="button-content">
      <el-button type="danger" @click="sure">清除</el-button>
      <el-button type="info" @click="close">取消</el-button>
    </div>
  </div>
  </modal>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'editorResizeTip',
  data () {
    return {
      type: '',
    }
  },
  computed: {
    ...mapGetters([
      'TOOL'
    ])
  },
  mounted () {
  },
  methods: {
    resizeTipOpen (e) {
      this.type = e.params.data
    },
    sure () {
      let undoData = {
            type: this.type,
            scenes: [],
            scale: this.TOOL.scale
          },
          info = {};
      this.TOOL.sprites.forEach(s => {
        if(s.camera.cameras.length) {
          info = {
            id: s.id,
            cameras: s.camera.cameras
          }
          undoData.scenes.push(info);
          s.camera._defaultC();
          this.$store.commit('toggle_cameras', s.camera.cameras);
          this.$store.commit('toggle_lensIndex', -1);
          s.camera.init()
        }
      });
      eve("undo_redo", null, {
        type: 'editor_resize', 
        data: undoData
      })
      this.TOOL.setOptimized(this.type);
      this.$modal.hide('editorResizeTip');
    },
    close () {
      this.$modal.hide('editorResizeTip');
    }
  }
}
</script>

<style lang="scss" scoped>
.resize-tip {
  position: relative;
  width: 420px;
  height: 210px;
  background: #fff;
  border-radius: 3px;
  overflow: hidden;
}
.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 12px 0 15px;
  height: 28px;
  color: #474261;
}
div.close-button {
  position: absolute;
  right: 10px;
  top: 5px;
  width: 16px;
  cursor: pointer;
}
i {
  position:relative;
  left: 7px;
  top: 5px;
  width: 2px;
  height: 15px;
  border-radius: 3px;
  background: #737596;
  transform: rotate(45deg);
  display: inline-block;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 2px;
    height: 15px;
    border-radius: 3px;
    background: #737596;
    transform: rotate(270deg);
  }
}
.content {
  color: #666;
  font-size: 14px;
  margin: 26px;
  text-align: center;
  div {
    line-height: 2.5;
  }
}
.button-content {
  display: flex;
  padding: 0 45px;
  justify-content: space-evenly;
  text-align: center;

  button {
    height: 40px;
    padding: 10px 45px;
  }

  .el-button--info {
    background: #EAEAF6;
    border-color: #EAEAF6;
    color: #666;

    &:hover {
      background: #d8d8e9;
      border-color: #d8d8e9;
    }
  }

  .el-button--danger {
    background: rgb(241, 36, 60);
    border-color: rgb(241, 36, 60);
    &:hover {
      background: #e53449;
      border-color: #e53449;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/emodal/editorResize.vue